<script lang="ts">
  import { onMount } from "svelte";
  import SearchHeader from "../../components/SearchHeader.svelte";
  import { Table } from "../../components/Table";
  import MainLayout from "../../layout/MainLayout.svelte";
  import { dealDtoFields } from "../../utils/TableFields/deal-dto.fields";
  import {
    filter,
    loading,
    records,
    pagination,
    initList,
    onCreate,
    onEdit,
    onDelete,
    onPageChange,
    search,
    tableCustomFields,
  } from "./deal.store";

  $: tableFields = [...dealDtoFields, ...$tableCustomFields];

  onMount(initList);
</script>

<MainLayout>
  <SearchHeader
    entitySingular="deal"
    entityPlural="deals"
    numRecords={$pagination != null ? $pagination.totalRecords : 0}
    bind:searchValue={$filter.criteria.query}
    on:search={search}
  />

  <Table
    loading={$loading}
    fields={tableFields}
    records={$records}
    pagination={$pagination}
    createEnabled={true}
    editEnabled={true}
    deleteEnabled={true}
    on:create={(_) => onCreate()}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
</MainLayout>
